import React from "react";
import Layout from "../../components/layout/Layout";
import ChemicalControlListTable from "../../components/tables/chemical/ChemicalControlListTable";

export default function ChemicalControlList() {
  return (
    <Layout>
      <ChemicalControlListTable />
    </Layout>
  );
}
